// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"ad251bcf","212":"9464cf16","268":"cea71c84","288":"724b0982","592":"2b1ee153","688":"e401476e","765":"40632adf","860":"47ec9ac4"}[chunkId] + ".chunk.js";
};